import { ComponentGroupInfo } from './index'

const data: ComponentGroupInfo = {
  id: 'layout',
  title: '布局',
  list: [
    {
      id: 'div',
      title: 'div',
      ext: {
        icon: 'mpd-icon-div',
        childrenComponent: []
      }
    }
  ]
}

export default data
